import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shippingLabelModalActions, shippingLabelModalAsyncActions, shippingLabelModalSelectors } from './services';
import { ModalProps } from '@/Types';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { AddressValidationResolvingModal } from '@/ModalWindows/AddressValidationResolvingModal/AddressValidationResolvingModal';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { OrderAutomatizaionModal } from '../OrderAutomatizationModal/OrderAutomatizationModal';
import { ShippingLabelStep } from '@/ModalWindows/ShippingLabelModal/Types';
import { OrderLabelPrintModal } from '../OrderLabelPrintModal/OrderLabelPrintModal';
import { orderLabelPrintActions } from '../OrderLabelPrintModal/services';
import { genLogisticTypesDataAsyncActions } from '@/Redux/DynamicData/GenLogisticTypesData/reducer';
import { orderAutomatizationActions } from '../OrderAutomatizationModal/services/reducer';
import { SelectWarehouseModal } from './modules/SelectWarehouseModal/SelectWarehouseModal';
import { tourSelectors } from '@/Redux/Tours/selectors';

export function ShippingLabelModal({ closeModalWindow }: ModalProps) {
  const dispatch: AppDispatch = useDispatch();

  const runTour = useSelector(tourSelectors.runTour);
  const selectedOrderIds = useSelector(salesPageSelectors.selectedSalesIds);
  const currentStep = useSelector(shippingLabelModalSelectors.currentShippingLabelStep);

  const onCloseModal = () => {
    closeModalWindow();
    dispatch(shippingLabelModalActions.setShippingLabelStep(ShippingLabelStep.Close));
  };

  useEffect(() => {
    if (!runTour) {
      dispatch(genLogisticTypesDataAsyncActions.getLogisticTypes());
      dispatch(shippingLabelModalAsyncActions.validateOrderAddresses({ orderIds: selectedOrderIds }));
    }

    return () => {
      dispatch(shippingLabelModalActions.resetState());
      dispatch(orderAutomatizationActions.resetState());
      dispatch(orderLabelPrintActions.resetState());
    };
  }, []);

  switch (currentStep) {
    case ShippingLabelStep.Validation:
      return <AddressValidationResolvingModal closeModalWindow={onCloseModal} />;

    case ShippingLabelStep.SelectWarehouse:
      return <SelectWarehouseModal isSales={true} closeModalWindow={onCloseModal} />;

    case ShippingLabelStep.OrderWithoutAutomatizaion:
      return <OrderAutomatizaionModal closeModalWindow={onCloseModal} />;

    case ShippingLabelStep.OrderLabelPrint:
      return <OrderLabelPrintModal closeModalWindow={onCloseModal} />;

    case ShippingLabelStep.None:
      return null;

    case ShippingLabelStep.Close:
    default:
      closeModalWindow();
      return null;
  }
}
